module.exports = __webpack_public_path__ + "img/dark.25617d06.png";